import { Paged } from 'api/common/types/Page';
import Http from '../../common/services/Http';
import { StoppingAreaDto } from './models/StoppingAreaDto';
import { StoppingAreaSearchCriteria } from './models/StoppingAreaSearchCriteria';

class StoppingAreasService {
    public getById(id: string) {
        return Http.get<StoppingAreaDto>('stoppingareas/' + id);
    }

    public getList(criteria: StoppingAreaSearchCriteria) {
        return Http.get<Paged<StoppingAreaDto>>('stoppingareas', criteria);
    }

    public create(model: StoppingAreaDto) {
        return Http.post<string>('stoppingareas', model);
    }

    public update(model: StoppingAreaDto) {
        return Http.put<string>('stoppingareas/' + model.id, model);
    }

    public remove(model: StoppingAreaDto) {
        return Http.put(`stoppingareas/${model.id}/deactivate`, model);
    }
}

export default new StoppingAreasService();
